<template>
  <div>
    <app-spinner v-if="!is_loaded" />
    <template v-else>
      <app-cells>
        <h1 class="title">Sales manager’s allowance ({{ dateFormat(allowance.month) }})</h1>
      </app-cells>
      <div class="info-cards">
        <div class="info-cards__card">
          <div class="info-cards__row">
            <div class="info-cards__row-item info-cards__row-item--full">
              <span>Sales:</span> <span>{{ allowance.leads_new_amount.toLocaleString() }} USD</span>
            </div>
          </div>
          <div class="info-cards__row">
            <div class="info-cards__row-item info-cards__row-item--full">
              <span>Commission:</span> <span>{{ allowance.leads_new_commission.toLocaleString() }} USD</span>
            </div>
          </div>
          <div class="info-cards__row">
            <div class="info-cards__row-item info-cards__row-item--full">
              <span>Bonus:</span> <span>{{ allowance.total_bonus.toLocaleString() }} USD</span>
            </div>
          </div>
        </div>
        <div class="info-cards__card">
          <div class="info-cards__row">
            <div class="info-cards__row-item info-cards__row-item--full">
              <span>Penalties:</span> <span>{{ allowance.current_month_penalty.toLocaleString() }} USD</span>
            </div>
          </div>
        </div>
      </div>
      <app-tabs :tabs="tabs" />
      <transition name="fade" mode="out-in">
        <router-view />
      </transition>
    </template>
  </div>
</template>

<script>
import AppTabs from '@/components/AppTabs'
import { format, parse } from 'date-fns'
import { getEmployeesUTTAllowance } from '@/http'

export default {
  name: 'AllowanceDetailLayout',
  components: { AppTabs },
  data() {
    return {
      is_loaded: false,
      tabs: [
        { name: 'allowance-employee', label: 'Employee' },
        { name: 'allowance-log', label: 'Log' },
      ],
      allowance: {},
    }
  },
  created() {
    getEmployeesUTTAllowance(this.$route.params.id)
      .then(res => {
        this.allowance = res.data
        this.is_loaded = true
      })
  },
  methods: {
    dateFormat(date) {
      return format(parse(date, 'yyyy-MM-dd', new Date()), 'MMM yyyy')
    },
  }
}
</script>
